const animationSwitchButtons = document.querySelectorAll('[data-switch-animation]');
const animationPanels = document.querySelectorAll('[data-animation-video]');

export function loadVideos() {
    animationPanels.forEach((panel) => {
        if (!panel.classList.contains('hidden')) {
            const video = panel.querySelector('iframe');

            if (!video.hasAttribute('src')) {
                // Load mobile video instead of desktop
                if (window.innerWidth <= 768) {
                    video.setAttribute('data-src', video.getAttribute('data-src').replace('928766747', '928775565').replace('928766731', '928775538'));
                    video.setAttribute('style', 'aspect-ratio: 9/16;');
                }

                video.setAttribute('src', video.getAttribute('data-src'));
            }
        }
    });
}

export function togglePanels() {
    animationPanels.forEach((panel) => {
        panel.classList.toggle('hidden');
    });
}

export default function initAnimationVideos() {
    if (animationSwitchButtons && animationPanels[0]) {
        animationSwitchButtons.forEach((element) => {
            element.addEventListener('click', (e) => {
                e.preventDefault();

                togglePanels();
                loadVideos();
            });
        });

        window.addEventListener('scroll', () => {
            // eslint-disable-next-line max-len
            const positionAnimationPanel = (window.scrollY + animationPanels[0].getBoundingClientRect().top) - 1000;

            if (window.scrollY > positionAnimationPanel) {
                loadVideos();
            }
        });
    }
}
